<template>
  <div class="form">
    <el-form ref="form" :model="form" label-width="80px" label-position="left" :rules="rules">
      <el-form-item label="账号" prop="account" required>
        <el-input
          v-model="form.account"
          size="mini"
          style="width: 150px"
        ></el-input>
      </el-form-item>
      <el-form-item label="角色" prop="type" required>
        <el-radio-group v-model="form.type" size="mini" class="user-type">
          <el-radio :label="303" :disabled="!hasAuth('132')">管理员</el-radio>
          <el-radio :label="304">普通账户</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="所属企业" prop="company_id" required>
        <el-select v-model="form.company_id" placeholder="请选择">
          <el-option
            v-for="item in companyList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="邮箱" prop="email" required>
        <el-input
          v-model="form.email"
          size="mini"
          style="width: 290px"
        ></el-input>
      </el-form-item>
      <el-form-item label="登录密码" prop="password" required>
        <el-input
          v-model="form.password"
          size="mini"
          style="width: 150px"
          type="password"
        ></el-input>
      </el-form-item>
      <el-form-item class="edit-buttons">
        <el-button type="primary" @click="onSubmit">保存</el-button>
        <el-button @click="$emit('close')" plain>取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { hasAuth } from 'utils/auth';

export default {
  name: 'EditCustomer',
  data() {
    return {
      form: {},
      item: {},
      rules: {
        account: [{ required: true, message: '请输入账号'}],
        type: [{ required: true, message: '请选择角色'}],
        company_id: [{ required: true, message: '请选择所属企业'}],
        email: [{ required: true, message: '请输入邮箱'}],
        password: [{ required: true, message: '请输入密码'}],
      },
    };
  },
  computed: {
    companyList() {
      return this.$store.state.company.list || [];
    }
  },
  methods: {
    hasAuth(val) {
      return hasAuth(val);
    },
    initForm(item) {
      this.$refs.form.resetFields();
      this.form = {};
      this.item = item;
      this.$store.dispatch('company/fetch', {
        pageSize: 1000
      });
      if (item && item !== 'create') {
        this.form = item;
      }
    },
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.form.id && this.form !== 'create') {
            this.$store
              .dispatch('customer/update', {
                ...this.form
              })
              .then(() => {
                this.$emit('close');
              });
          } else {
            this.$store
              .dispatch('customer/create', {
                ...this.form
              })
              .then(() => {
                this.$emit('close');
              });
          }
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.form {
  background: #fff;
  .el-form-item {
    padding: 14px 0 14px 24px;
    margin: 0;
    border-bottom: 1px solid #e9edf0;
    &:last-child {
      border-bottom: none;
    }
    .user-type {
      width: 100%;
      display: flex;
      align-items: center;
      height: 40px;
      .el-radio {
        margin-right: 24px;
      }
    }

    &.edit-buttons {
      display: flex;
      margin-right: 24px;
      justify-content: flex-end;
    }
  }
}
</style>
